











































import { Component, Prop, Ref, VModel, Vue, Watch } from 'vue-property-decorator';
import Autocomplete from '../components/Autocomplete.vue';

@Component({})
export default class WorkTaskTypeSelect extends Vue {

    @VModel() innerValue!: string;
    @Prop({ default: "" }) label!: string;
    @Prop() type!: string | Array<string>;
    @Prop() readonly!: boolean;
    @Prop() rules!: [ any[] ];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) createParty!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: true }) clearable!: boolean;
    @Prop({ default: true }) simple!: boolean;
    @Prop() placeholder!: string;

    @Ref() autocomplete!: Autocomplete;

    get items(): any[] {
        return [
            {
                value: "Charged",
                text: this.$i18n.t("common.paidTasks"),
                color: "primary"
            },
            {
                value: "Free",
                text: this.$i18n.t("common.freeTask"),
                color: "pink"
            },
            {
                value: "",
                text: this.$i18n.t("common.all"),
                color: "green"
            },
        ];
    }

}
